<template>
    <painel titulo="Evento" icone="pi pi-calendar" :refreshFunction="atualizar" :mostrarRefresh="acao == 'ATUALIZAR'">
        <erros-box :erros="erros"></erros-box>
        <div class="formgrid grid p-fluid">
            <div class="field col-12 md:col-2">
                <label class="required">Código</label>
                <InputText type="text" v-model="codigo" @input="v$.codigo.$touch()" maxlength="100" />
                <small class="p-error" v-if="v$.codigo.$error">O código é obrigatório</small>
            </div>
            <div class="field col-12 md:col-2">
                <label>
                    Numero do Evento
                    <i class="pi pi-info-circle ml-1 text-secondary" v-tooltip.bottom="'Utilize o código FOCO'"></i>
                </label>
                <div class="p-inputgroup">
                    <InputText v-model="numeroInterno" placeholder="Ex: EV-24162" @focus="onNumeroEventoFocus" @blur="onNumeroEventoBlur" />
                    <Button icon="pi pi-search" @click="onLupaClick" />
                </div>
                <small class="p-error" v-if="v$.codigoInterno.$error">O código do evento é obrigatório</small>
            </div>
            <div class="field col-12 md:col-2" v-if="nivel == 0">
                <label class="required">Código Externo</label>
                <InputText type="text" v-model="codigoExterno" maxlength="100" :disabled="participantesInternos" @input="v$.codigoExterno.$touch()" />
                <small class="p-error" v-if="v$.codigoExterno.$error">O código externo é obrigatório</small>
            </div>
            <div class="field col-12" v-if="contasEventos && nivel == 0 && !participantesInternos">
                <label>Conta do Evento</label>
                <Dropdown
                    v-model="contaEventoId"
                    :options="contasEventos"
                    optionLabel="nome"
                    optionValue="contaEventoId"
                    :filter="true"
                    placeholder="Selecione a conta do evento"
                    :showClear="true"
                    :filterFields="['nome']"
                >
                </Dropdown>
            </div>
            <div class="field col-12">
                <label class="required"> Nome de Exibição </label>
                <InputText type="text" v-model="nome" maxlength="500" :disabled="participantesInternos" />
                <small class="p-error" v-if="v$.nome.$error">O nome é obrigatório</small>
            </div>
            <div class="field col-12">
                <label class="required">Descrição</label>
                <InputText type="text" v-model="descricao" @input="v$.descricao.$touch()" maxlength="1000" />
                <small class="p-error" v-if="v$.descricao.$error">A Descrição é obrigatória</small>
            </div>
            <div class="datas field col-2">
                <label>Data Início</label>
                <InputMask
                    v-model="dataInicioFormatada"
                    mask="99/99/9999"
                    placeholder="DD/MM/AAAA"
                    :disabled="participantesInternos"
                    @blur="v$.dataInicioFormatada.$touch()"
                />
                <small class="p-error" v-if="v$.dataInicioFormatada.$error">Data inválida</small>
            </div>
            <div class="datas field col-2">
                <label>Data Fim</label>
                <InputMask
                    v-model="dataFimFormatada"
                    mask="99/99/9999"
                    placeholder="DD/MM/AAAA"
                    :disabled="participantesInternos"
                    @blur="v$.dataFimFormatada.$touch()"
                />
                <small class="p-error" v-if="v$.dataFimFormatada.$error">Data inválida</small>
            </div>
            <div class="field field-checkbox col-12 md:col-2">
                <Checkbox v-model="geraAtendimento" :binary="true" id="geraAtendimento" />
                <label for="geraAtendimento">Gera Atendimento</label>
            </div>
            <div class="field field-checkbox col-12 md:col-2" v-if="nivel == 0">
                <Checkbox v-model="sincronizarCheckinExterno" :binary="true" id="sincronizarCheckinExterno" :disabled="participantesInternos" />
                <label for="sincronizarCheckinExterno">Sincronizar Checkin Externo</label>
            </div>
            <div class="field field-checkbox col-12 md:col-2" v-if="nivel == 0">
                <Checkbox v-model="pesquisarSomenteBaseEvento" :binary="true" id="pesquisarSomenteBaseEvento" />
                <label for="pesquisarSomenteBaseEvento">Pesquisar Somente na Base do Evento</label>
            </div>
            <div class="field field-checkbox col-12 md:col-2" v-if="nivel == 0">
                <Checkbox v-model="naoExibirFormularioNovoCredenciamento" :binary="true" id="naoExibirFormularioNovoCredenciamento" />
                <label for="naoExibirFormularioNovoCredenciamento">Não apresentar formulário de novo credenciamento</label>
            </div>
            <div class="field field-checkbox col-12 md:col-2" v-if="mostrarChkBuscarCnpj">
                <Checkbox v-model="buscarCnpj" :binary="true" id="buscarCnpj" />
                <label for="buscarCnpj">Buscar CNPJ</label>
            </div>
            <div class="field field-checkbox col-12 md:col-2">
                <Checkbox v-model="participantesInternos" :binary="true" id="participantesInternos" />
                <label for="participantesInternos">Obter Participantes do FOCO</label>
            </div>
            <div class="field col-4">
                <label :class="{ required: comercializacaoObrigatoria }">Comercialização</label>
                <Dropdown
                    v-model="comercializacaoSelecionada"
                    :options="tiposComercializacao"
                    optionLabel="pricebook2.name"
                    placeholder="Selecione a comercialização"
                    :showClear="true"
                    :filter="true"
                    :filterFields="['pricebook2.name']"
                    @blur="v$.comercializacaoSelecionada.$touch()"
                />
                <small class="p-error" v-if="v$.comercializacaoSelecionada.$error">A comercialização é obrigatória. </small>
                <small class="p-error" v-if="comercializacaoObrigatoria && tiposComercializacao.length === 0"
                    >Não há tipos de comercialização disponíveis. Não é possível salvar.</small
                >
            </div>
        </div>
        <Divider />
        <slot name="botoes"></slot>
        <Button label="Cancelar" icon="pi pi-times-circle" class="p-button-secondary" @click="cancelar" />
        <Button label="Salvar" icon="pi pi-check-circle" class="ml-2 p-button-primary" @click="confirmarSalvar()" :disabled="v$.$invalid" />
    </painel>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import EventosServices from './services';

export default {
    setup() {
        return { v$: useVuelidate() };
    },

    props: {
        acao: {
            type: String,
        },

        evento: {
            type: Object,
        },

        erros: {
            type: Array,
        },

        cancelar: {
            type: Function,
        },

        nivel: {
            type: Number,
        },

        eventoPaiId: {
            type: String,
        },

        eventoPaiBuscaCnpj: {
            type: Boolean,
        },
    },

    emits: ['salvar', 'atualizar'],

    data() {
        return {
            aplicarRfid: false,
            rfidAlterada: false,
            codigoInterno: null,
            codigoInternoNoFocus: null,
            codigoExterno: '0',
            descricao: null,
            dataInicio: null,
            dataFim: null,
            dataInicioFormatada: null,
            dataFimFormatada: null,
            codigo: null,
            nome: null,
            contaEventoId: null,
            geraAtendimento: false,
            sincronizarCheckinExterno: false,
            pesquisarSomenteBaseEvento: false,
            naoExibirFormularioNovoCredenciamento: false,
            buscarCnpj: true,
            contasEventos: [],
            participantesInternos: false,
            numeroInterno: null,
            numeroEventoNoFocus: null,
            disponibilizacaoId: null,
            comercializacaoId: null,
            comercializacaoSelecionada: null,
            tiposComercializacao: [],
        };
    },

    validations() {
        return {
            nome: { required },
            descricao: { required },
            codigo: { required },
            codigoInterno: {
                codigoInternoOk: () => {
                    return this.codigoInternoOk;
                },
            },
            codigoExterno: {
                codigoExternoOk: () => {
                    return this.codigoExternoOk;
                },
            },
            geraAtendimento: { required },
            sincronizarCheckinExterno: { required },
            buscarCnpj: { required },
            comercializacaoSelecionada: {
                comercializacaoOk: () => {
                    return this.comercializacaoOk;
                },
            },
            dataInicioFormatada: {
                dataValida: () => {
                    return this.validarData(this.dataInicioFormatada);
                },
            },
            dataFimFormatada: {
                dataValida: () => {
                    return this.validarData(this.dataFimFormatada);
                },
            },
        };
    },

    computed: {
        codigoInternoOk() {
            // "Quer FOCO" = marcou obter participantes do FOCO OU digitou o número do evento
            const querFoco = this.participantesInternos || (this.numeroInterno != null && this.numeroInterno !== '' && this.numeroInterno !== '0');
            if (!querFoco) {
                return true; // evento sem FOCO é válido em qualquer nível (pai ou filho)
            }
            // Sinalizou FOCO → o código interno precisa ter sido resolvido
            return this.codigoInterno != null && this.codigoInterno != '' && this.codigoInterno != '0';
        },

        codigoExternoOk() {
            if (this.nivel == 0) {
                return this.codigoExterno != null && this.codigoExterno != '';
            }
            return true;
        },

        comercializacaoOk() {
            // Se há código interno preenchido e diferente de 0, comercialização é obrigatória
            if (this.comercializacaoObrigatoria) {
                return this.tiposComercializacao.length > 0 && this.comercializacaoSelecionada != null;
            }
            // Se não há código interno ou é 0, comercialização não é obrigatória
            return true;
        },

        comercializacaoObrigatoria() {
            // Comercialização é obrigatória quando há código interno preenchido e diferente de 0
            return this.codigoInterno != null && this.codigoInterno !== '' && this.codigoInterno !== '0';
        },

        pbcnpj() {
            if (!this.evento) {
                return this.eventoPaiBuscaCnpj;
            }
            return this.evento.eventoPai.buscarCnpj;
        },

        mostrarChkBuscarCnpj() {
            return this.nivel == 0 || (this.nivel != 0 && !this.pbcnpj);
        },

        conteudoOK() {
            return true;
        },

        hojeSemHorario() {
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);
            return hoje;
        },
    },

    methods: {
        obterContasEventos() {
            this.$store.dispatch('addRequest');
            EventosServices.obterContasEventos()
                .then((response) => {
                    if (response?.success) {
                        this.contasEventos = response.data;
                    } else {
                        this.contasEventos = [];
                    }
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },

        obterTiposComercializacao(disponibilizacaoId) {
            if (!disponibilizacaoId) {
                return;
            }
            this.$store.dispatch('addRequest');
            EventosServices.pesquisarTiposComercializacao(disponibilizacaoId)
                .then((response) => {
                    if (response?.success) {
                        this.tiposComercializacao = response.data;
                        if (this.evento?.comercializacaoId) {
                            this.comercializacaoSelecionada = this.tiposComercializacao.find((x) => x.id === this.evento.comercializacaoId);
                        }
                    } else {
                        this.tiposComercializacao = [];
                    }
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },

        preencher() {
            this.codigoExterno = this.evento?.codigoExterno;
            this.codigoInterno = this.evento?.codigoInterno;
            this.numeroInterno = this.evento?.numeroInterno;
            this.disponibilizacaoId = this.evento?.disponibilizacaoId;
            this.descricao = this.evento?.descricao;
            this.codigo = this.evento?.codigo;
            this.nome = this.evento?.nome;
            this.geraAtendimento = this.evento?.geraAtendimento;
            this.sincronizarCheckinExterno = this.evento?.sincronizarCheckinExterno;
            this.pesquisarSomenteBaseEvento = this.evento?.pesquisarSomenteBaseEvento;
            this.naoExibirFormularioNovoCredenciamento = this.evento?.naoExibirFormularioNovoCredenciamento;
            this.buscarCnpj = this.evento?.buscarCnpj;
            this.contaEventoId = this.evento?.contaEventoId;
            this.participantesInternos = this.evento?.participantesInternos;
            this.comercializacaoId = this.evento?.comercializacaoId;
            this.dataInicio = this.evento?.dataInicio ? new Date(this.evento.dataInicio) : null;
            this.dataFim = this.evento?.dataFim ? new Date(this.evento.dataFim) : null;
            this.dataInicioFormatada = this.$dateFormat(this.evento?.dataInicio, 'DD/MM/yyyy');
            this.dataFimFormatada = this.$dateFormat(this.evento?.dataFim, 'DD/MM/yyyy');

            // Se for atualização e tiver número do evento diferente de 0
            if (this.acao === 'ATUALIZAR' && this.numeroInterno && this.numeroInterno !== '0') {
                this.pesquisarEvento();
                this.obterTiposComercializacao(this.disponibilizacaoId);
            } else {
                this.comercializacaoSelecionada = this.tiposComercializacao.find((x) => x.id === this.evento?.comercializacaoId);
            }

            this.v$.$touch();
        },

        confirmarSalvar() {
            this.$confirm.require({
                message: `Tem certeza que deseja ${this.acao.toLowerCase()} o evento?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.salvar();
                },
            });
        },

        salvar() {
            let eventoDto = {
                codigo: this.codigo,
                // Sem FOCO → envia a sentinela "0" (o backend só pula a busca no FOCO quando CodigoInterno == "0")
                codigoInterno: this.codigoInterno && this.codigoInterno !== '' ? this.codigoInterno : '0',
                numeroInterno: this.numeroInterno,
                codigoExterno: this.codigoExterno,
                nome: this.nome,
                descricao: this.descricao,
                nivel: this.nivel,
                eventoPaiId: null,
                geraAtendimento: this.geraAtendimento,
                sincronizarCheckinExterno: this.sincronizarCheckinExterno,
                pesquisarSomenteBaseEvento: this.pesquisarSomenteBaseEvento,
                naoExibirFormularioNovoCredenciamento: this.naoExibirFormularioNovoCredenciamento,
                buscarCnpj: this.buscarCnpj,
                contaEventoId: this.contaEventoId,
                participantesInternos: this.participantesInternos,
                dataInicio: this.dataInicio instanceof Date ? this.dataInicio.toISOString() : this.dataInicio,
                dataFim: this.dataFim instanceof Date ? this.dataFim.toISOString() : this.dataFim,
                comercializacaoId: this.comercializacaoSelecionada?.id ?? null,
                comercializacaoDesc: this.comercializacaoSelecionada?.pricebook2?.name ?? null,
            };

            if (this.nivel != 0) {
                eventoDto.eventoPaiId = this.eventoPaiId;
            }

            this.$emit('salvar', eventoDto);
        },

        atualizar() {
            this.$emit('atualizar');
        },

        pesquisarEvento() {
            if (!this.numeroInterno || this.numeroInterno === '0') {
                return;
            }

            this.$store.dispatch('addRequest');
            EventosServices.pesquisarEventoInterno(this.numeroInterno)
                .then((response) => {
                    if (response?.success) {
                        this.codigoInterno = response.data.codEvento;
                        this.nome = response.data.titulo;
                        this.descricao = response.data.descricao;
                        this.dataInicio = response.data.dataInicio ? new Date(response.data.dataInicio) : null;
                        this.dataFim = response.data.dataFim ? new Date(response.data.dataFim) : null;
                        this.dataInicioFormatada = this.$dateFormat(response.data.dataInicio, 'DD/MM/yyyy');
                        this.dataFimFormatada = this.$dateFormat(response.data.dataFim, 'DD/MM/yyyy');
                        this.disponibilizacaoId = response.data.disponibilizacaoId;

                        if (this.disponibilizacaoId) {
                            this.obterTiposComercializacao(this.disponibilizacaoId);
                        }
                    } else {
                        this.$emit('atualizarErros', response.errors);
                    }
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest');
                });
        },

        onLupaClick() {
            if (this.numeroInterno && this.numeroInterno !== '0') {
                this.pesquisarEvento();
            }
        },

        onNumeroEventoFocus() {
            this.numeroEventoNoFocus = this.numeroInterno;
        },

        onNumeroEventoBlur() {
            if (this.numeroInterno && this.numeroInterno !== '0' && this.numeroInterno !== this.numeroEventoNoFocus) {
                this.pesquisarEvento();
            }
        },

        onCodigoInternoFocus() {
            this.codigoInternoNoFocus = this.codigoInterno;
        },

        onCodigoInternoBlur() {
            if (this.codigoInterno && this.codigoInterno !== this.codigoInternoNoFocus && this.codigoInterno !== '0') {
                this.pesquisarEvento();
            }
        },

        onRfidChange(checked) {
            this.aplicarRfid = checked;
            this.rfidAlterada = true;
        },

        validarData(dataString) {
            if (!dataString || dataString.includes('_')) {
                return true;
            }

            const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
            const match = dataString.match(regex);

            if (!match) {
                return false;
            }

            const dia = parseInt(match[1], 10);
            const mes = parseInt(match[2], 10);
            const ano = parseInt(match[3], 10);

            if (mes < 1 || mes > 12) {
                return false;
            }

            const diasPorMes = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

            if (mes === 2 && ((ano % 4 === 0 && ano % 100 !== 0) || ano % 400 === 0)) {
                diasPorMes[1] = 29;
            }

            if (dia < 1 || dia > diasPorMes[mes - 1]) {
                return false;
            }

            return true;
        },

        converterDataParaISO(dataString) {
            if (!dataString || !this.validarData(dataString)) {
                return null;
            }

            const [dia, mes, ano] = dataString.split('/');
            return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        },
    },

    watch: {
        evento() {
            if (this.evento) {
                this.preencher();
            }
        },

        tiposComercializacao() {
            // Quando a lista de tipos for atualizada, tenta encontrar a comercialização selecionada
            if (this.evento?.comercializacaoId && this.tiposComercializacao.length > 0) {
                const comercializacaoEncontrada = this.tiposComercializacao.find((x) => x.id === this.evento.comercializacaoId);
                if (comercializacaoEncontrada && !this.comercializacaoSelecionada) {
                    this.comercializacaoSelecionada = comercializacaoEncontrada;
                }
            }
        },

        participantesInternos() {
            if (this.participantesInternos) {
                this.codigoExterno = '0';
                this.sincronizarCheckinExterno = 0;
                this.contaEventoId = null;
                if (this.disponibilizacaoId) {
                    this.obterTiposComercializacao(this.disponibilizacaoId);
                }
            } else {
                if (!this.codigoInterno || this.codigoInterno === '') {
                    this.codigoInterno = '0';
                }
            }
        },

        dataInicioFormatada(newValue) {
            if (!newValue || newValue.includes('_')) {
                return;
            }

            if (this.validarData(newValue)) {
                const isoString = this.converterDataParaISO(newValue);
                if (isoString) {
                    this.dataInicio = new Date(isoString + 'T00:00:00.000Z');
                }
            }
        },

        dataFimFormatada(newValue) {
            if (!newValue || newValue.includes('_')) {
                return;
            }

            if (this.validarData(newValue)) {
                const isoString = this.converterDataParaISO(newValue);
                if (isoString) {
                    this.dataFim = new Date(isoString + 'T00:00:00.000Z');
                }
            }
        },
    },

    created() {
        this.obterContasEventos();
    },
};
</script>
